<template>
    <div>

        <div class="columns">
            <div @click="dailyShowModal = true" class="column has-text-centered card-m">
                <div class="card card-1">
                    <div class="card__icon">Statistics of Last Day</div>
                    <h1 class="card__title is-size-4">{{daily.startDt|shortFormatDateString}} between {{daily.endDt|shortFormatDateString}}</h1>
                </div>
            </div>
            <div @click="weeklyShowModal = true" class="column has-text-centered card-m">
                <div class="card card-1">
                    <div class="card__icon">Statistics of Last 7 Days</div>
                    <h2 class="card__title is-size-4">{{weekly.startDt|shortFormatDateString}} between {{weekly.endDt|shortFormatDateString}}</h2>
                </div>
            </div>
            <div @click="monthlyShowModal = true" class="column has-text-centered card-m">
                <div class="card card-1">
                    <div class="card__icon">Statistics of Last 30 Days</div>
                    <h2 class="card__title is-size-4">{{monthly.startDt|shortFormatDateString}} between {{monthly.endDt|shortFormatDateString}}</h2>
                </div>
            </div>
        </div>
        <div class="column box bg" style="overflow-x:auto; min-height: 700px">
            <!--            <div class="column search">-->
            <!--                <div class="field has-addons is-pulled-left">-->
            <!--                    <div class="control">-->
            <!--                        <input class="input is-normal" type="text" v-model="search" placeholder="Find a Archive"-->
            <!--                               @change="fillsearchField()">-->
            <!--                    </div>-->
            <!--                    <div class="control">-->
            <!--                        <a class="button btn-color bg-white">-->
            <!--                            <font-awesome-icon class="is-size-5 color-default" icon="search"/>-->
            <!--                        </a>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="columns is-mobile">
                <div class="column">
                    <div class="field has-addons is-pulled-left">
                        <div class="control">
                            <input class="input is-normal input-width" type="text" v-model="search"
                                   placeholder="Search a Report Summary">
                        </div>
                        <div class="control">
                            <a class="button">
                                <font-awesome-icon class="is-size-5 color-default" icon="search"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field has-addons is-pulled-right">
                        <div class="control">
                            <!--              <input class="input is-normal input-width" :type="customFormatter" v-model="forceSelectedDay">-->

                            <datepicker style="inline-size: auto" :monday-first="true"
                                        input-class="input-class"
                                        @opened="openDateCalendar"
                                        @closed="TrygetScheduleFlightsfromDatepicker"
                                        v-model="datepickerDate"
                                        :format="customFormatter">
                            </datepicker>

                        </div>
                        <div class="control">
                            <button class="button is-primary btn-color is-small">
                                <font-awesome-icon icon="sync-alt"></font-awesome-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns"  style="justify-content: right;">
                <div class="has-text-right" style="padding-right: 10px">
                    <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                        <div class="tooltiptext">
                            <ul style="list-style: disc outside">
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can sort Archive Summary by ID, KFZ, Archive ID, Flight Folder Size, Archive DT, Stat, Last Error</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can search Archive Summary by ID, KFZ, Archive ID, Flight Folder Size, Archive DT, Stat, Last Error</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can view Archive and Deletion Summary on the Grid.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <table>
                <thead>
                <tr>
                    <th></th>
                    <th>
                        <button class="t-sort" @click="sortBy('id')">ID
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'id' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'id')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('kfz')">KFZ
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'kfz' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'kfz')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('archiveId')">ArchiveID
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'archiveId' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'archiveId')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('flightFolderSize')">Flight Folder Size
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'flightFolderSize' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'flightFolderSize')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('stdDay')">Archive DT
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'stdDay' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'stdDay')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('stat')">Stat
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'stat' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'stat')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('lastError')">Last Error
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'lastError' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'lastError')"/>
                        </button>
                    </th>
                </tr>
                </thead>
                <tbody v-if="paginate && paginate.length">
                <template v-for="(archive, index) in paginate">
                    <tr :key="archive.id + '_' + index"
                        :class="!isToggleActived[archive.id] ? 'bg-default' : 'bg-white'">
                        <td @click="toggle(archive.id)">
                            <font-awesome-icon :icon="icon(opened.includes(archive.id))" size=""/>
                        </td>
                        <td :class="sort === 'id' ? 'bg-sort-selected' : 'bg-default'">{{ archive.id }}</td>
                        <td :class="sort === 'kfz' ? 'bg-sort-selected' : 'bg-default'">{{ archive.kfz }}</td>
                        <td :class="sort === 'archiveId' ? 'bg-sort-selected' : 'bg-default'">{{ archive.archiveId }}
                        </td>
                        <td :class="sort === 'flightFolderSize' ? 'bg-sort-selected' : 'bg-default'">{{
                            archive.flightFolderSize }} MB
                        </td>
                        <td :class="sort === 'stdDay' ? 'bg-sort-selected' : 'bg-default'">{{ archive.stdDay }}</td>
                        <td :class="sort === 'stat' ? 'bg-sort-selected' : 'bg-default'">{{ archive.stat }}</td>
                        <td :class="sort === 'lastError' ? 'bg-sort-selected' : 'bg-default'" class="last-error">
                            {{archive.lastError}}
                        </td>
                    </tr>
                    <tr v-if="opened.includes(archive.id)" :key="archive.id">
                        <td colspan="8" class="table-center bg-white">
            <span class="box child-table-d-table info-card-color has-text-left">
              <font-awesome-icon class="info is-size-5" icon="info"/>
              <span>Deletion Summary Info of {{ archive.KFZ }}</span>
            </span>
                            <table class="box child-table-d-table">
                                <thead>
                                <tr class="bg-default">
                                    <th class="color-default" colspan="2">ID</th>
                                    <th class="color-default">KFZ</th>
                                    <th class="color-default">Archive ID</th>
                                    <th class="color-default">Full Path</th>
                                    <th class="color-default">Archive DT</th>
                                    <th class="color-default">Last Error</th>
                                    <th class="color-default">Deleted Folder Size</th>
                                </tr>
                                </thead>
                                <tbody v-if="opened.includes(archive.id)">
                                <tr v-for="deletion in archive.deletionSummary" :key="deletion.id">
                                    <td colspan="2">{{ deletion.id }}</td>
                                    <td>{{ deletion.kfz }}</td>
                                    <td>{{ deletion.folderName }}</td>
                                    <td>{{ deletion.fullPath }}</td>
                                    <td>{{ deletion.deletionDT }}</td>
                                    <td class="last-error">{{ deletion.lastError }}</td>
                                    <td>{{ deletion.deletedFolderSize }} MB</td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="">
            <div class="level" style="justify-content: center; margin-top: 20px">
                <nav class="pagination" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li v-if="pageNavigationInfo.hasFirstPageNavigation">
                            <div @click="setPage(1)" class="pagination-link bg-default color-default">
                                <font-awesome-icon class="is-size-5 color-default" icon="backward"/>
                            </div>
                        </li>
                        <li v-for="index in pageNavigationInfo.pageCount" :key="index">
                            <div
                                    :style="currentPage === pageNavigationInfo.start + index ? 'background-color:#6a85a7;' : 'background-color:#f8f6ff'"
                                    @click="setPage(pageNavigationInfo.start + index)" class="pagination-link">
                                <a :style="currentPage === pageNavigationInfo.start + index ? 'color:white;' : 'color:#6a85a7'"
                                   :class="[currentPage === pageNavigationInfo.start + index ? 'current':'']">{{
                                    pageNavigationInfo.start + index
                                    }}</a>
                            </div>
                        </li>
                        <li v-if="pageNavigationInfo.hasLastPageNavigation">
                            <div @click="setPage(pageNavigationInfo.total)"
                                 class="pagination-link bg-default color-default">
                                <font-awesome-icon class="is-size-5 color-default" icon="forward"/>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div class="modal daily-modal" id="daily-modal" :class="{ 'is-active': dailyShowModal }">
            <div class="modal-background" @click="dailyShowModal = false"></div>
            <div class="modal-card">
                <header class="modal-card-head" style="justify-content: space-between">
                    <h2>Statistics of Last Day</h2>
                    <button class="delete" aria-label="close" @click="dailyShowModal = false"></button>
                </header>
                <section class="modal-card-body" v-if="lockrendermodal">
                    <div class="columns justify-center">

                        <div class="mr-50px">
                            <p>Successful Archive Rate is %{{SuccessfullPercentageRateCalculation(daily.archivedTotalCount,daily.archivedErroredCount)}}</p>
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#48c774', '#f14668'], data: [(daily.archivedTotalCount === undefined)? 99 : daily.archivedTotalCount,
                                                                                                        (daily.erroredArchiveCount=== undefined)? 99:daily.erroredArchiveCount] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #48c774;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Total Count : {{ daily.archivedTotalCount }}</div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #f14668;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Errored Count : {{ daily.erroredArchiveCount }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mr-50px">
                            <p>Gained Archive Size Rate is %{{SuccessfullPercentageRateCalculation(daily.archivedTotalSize,deletedFolderSize)}}</p>
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#48c774', '#fda50f'], data: [(daily.archivedTotalSize===undefined)? 99 : daily.archivedTotalSize,
                                                                                                        (daily.deletedFolderSize=== undefined)? 99 : daily.deletedFolderSize] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #48c774;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Total Size : {{ daily.archivedTotalSize }} MB
                                    </div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #fda50f;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Folder Size : {{ daily.deletedFolderSize }} MB
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mr-50px">
                            <p>Succesfully Deletion Rate is %{{SuccessfullPercentageRateCalculation(daily.deletedFolderCount,daily.deleteErroredCount)}}</p>
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#fda50f', '#f14668'], data: [(daily.deletedFolderCount===undefined)? 99 : daily.deletedFolderCount,
                                                                                                        (daily.deleteErroredCount===undefined)? 99 : daily.deleteErroredCount] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                width: 35px;
                background: #fda50f;
                margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Folder Count : {{ daily.deletedFolderCount }}</div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #f14668;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Errored Count : {{ daily.deleteErroredCount }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">

                </footer>
            </div>
        </div>
        <div class="modal" id="weekly-modal" :class="{ 'is-active': weeklyShowModal }">
            <div class="modal-background" @click="weeklyShowModal = false"></div>
            <div class="modal-card">
                <header class="modal-card-head" style="justify-content: space-between">
                    <h2>Statistics of Last 7 Days</h2>
                    <button class="delete" aria-label="close" @click="weeklyShowModal = false"></button>
                </header>
                <section class="modal-card-body">
                    <div class="columns justify-center">
                        <div class="mr-50px">
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#48c774', '#f14668'], data: [ConvertStringToFloat(weekly.archivedTotalCount), ConvertStringToFloat(weekly.erroredArchiveCount)] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #48c774;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Total Count : {{ weekly.archivedTotalCount }}
                                    </div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #f14668;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Errored Count : {{ weekly.erroredArchiveCount }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mr-50px">
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#48c774', '#fda50f'], data: [ConvertStringToFloat(weekly.archivedTotalSize), ConvertStringToFloat(weekly.deletedFolderSize)] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #48c774;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Total Size : {{ weekly.archivedTotalSize }} MB
                                    </div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #fda50f;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Folder Size : {{ weekly.deletedFolderSize }} MB
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mr-50px">
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#fda50f', '#f14668'], data: [ConvertStringToFloat(weekly.deletedFolderCount), ConvertStringToFloat(weekly.deleteErroredCount)] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                width: 35px;
                background: #fda50f;
                margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Folder Count : {{ weekly.deletedFolderCount }}
                                    </div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #f14668;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Errored Count : {{ weekly.deleteErroredCount }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">

                </footer>
            </div>
        </div>
        <div class="modal" id="monthly-modal" :class="{ 'is-active': monthlyShowModal }">
            <div class="modal-background" @click="monthlyShowModal = false"></div>
            <div class="modal-card">
                <header class="modal-card-head" style="justify-content: space-between">
                        <h2 >Statistics of Last 30 Days</h2>
                        <button class="delete" aria-label="close" @click="monthlyShowModal = false"></button>
                </header>
                <section class="modal-card-body">
                    <div class="columns justify-center">
                        <div class="mr-50px">
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#48c774', '#f14668'], data: [ConvertStringToFloat(monthly.archivedTotalCount), ConvertStringToFloat(monthly.erroredArchiveCount)] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #48c774;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Total Count : {{ monthly.archivedTotalCount }}
                                    </div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #f14668;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Errored Count : {{ monthly.erroredArchiveCount}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mr-50px">
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#48c774', '#fda50f'], data: [ConvertStringToFloat(monthly.archivedTotalSize), ConvertStringToFloat(monthly.deletedFolderSize)] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #48c774;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Archived Total Size : {{ monthly.archivedTotalSize }} MB
                                    </div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #fda50f;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Folder Size : {{ monthly.deletedFolderSize }} MB
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mr-50px">
                            <PieChart
                                    :pie-chart-data="{ backgroundColor: ['#fda50f', '#f14668'], data: [ConvertStringToFloat(monthly.deletedFolderCount), ConvertStringToFloat(monthly.deleteErroredCount)] }"/>
                            <div class="row">
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                width: 35px;
                background: #fda50f;
                margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Folder Count : {{ monthly.deletedFolderCount }}
                                    </div>
                                </div>
                                <div class="columns has-text-centered justify-center">
                                    <div style="height: 25px;
                      width: 35px;
                      background: #f14668;
                      margin-top: 20px"></div>
                                    <div style="margin:20px">Deleted Errored Count : {{ monthly.deleteErroredCount }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                </footer>
            </div>
        </div>
    </div>
</template>
<style>
    /*.column{*/
    /*  display: flex;*/
    /*  justify-content: center;*/
    /*}*/
    #pie-chart {
        min-width: 300px;
        min-height: 400px;
        max-height: 400px;
        z-index: 99999;
    }

    .modal-card-head {
        justify-content: right;
    }

    .delete {
        background-color: #f14668;
        padding: 15px;
    }

    .modal-card {
        width: 1400px !important;
        height: 700px !important;
    }

    .mr-50px {
        margin-right: 50px;
    }

    .input-class {
        height: 30px !important;
        width: 250px !important;
        margin-right: 1px !important;
    }

    .justify-center {
        justify-content: center;
    }

    .card-m {
        margin: 0;
        padding: 0;
    }

    .btn-color {
        background-color: #00d1b2;
        color: white;
    }

    .last-error {
        color: red;
    }

    .box:not(:last-child) {
        margin-bottom: 0.5rem;
    }

    .mt-5px {
        margin-top: 5px;
    }

    .bg-child-table {
        background-color: #b3b3b31c;
    }

    .child-table-d-table {
        display: table !important;
        width: 100%;
        pointer-events: none;
        background-color: white;
    }


    .heading__credits .heading__link {
        color: inherit;
    }

    .card {
        margin: 20px;
        min-width: 200px;
        max-height: 150px;
        display: grid;
        grid-template-rows: 20px 50px 1fr 50px;
        border-radius: 10px;
        box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.25);
        transition: all 0.2s;
    }

    .card:hover {
        box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.4);
        transform: scale(1.01);
    }


    .card__icon {
        grid-row: 2/3;
        font-size: 30px;
        color: #6a85a7;
        position: relative;
        text-decoration: none;
    }

    .card__title {
        grid-row: 3/4;
        font-weight: 400;
        color: #6a85a7;
    }

    .card-1 {
        background: radial-gradient(#f8f6ff, #f8f6ff);
    }

    ol.collection {
        margin: 0px;
        padding: 0px;
    }

    .child-table-d-table {
        display: table !important;
        width: 85%;
        pointer-events: none;
    }

    li {
        list-style: none;
    }

    * {
        box-sizing: border-box;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
    }

    th {
        color: white !important;
    }

    th, td {
        text-align: left;
        padding: 8px;
    }

    thead tr:nth-child(1) {
        background-color: #6a85a7;
    }


    table > tbody > tr > table tr:nth-child(1) {
        background-color: #ffffff
    }

    .box {
        color: #6a85a7;
    }

    .heading__credits .heading__link {
        color: inherit;
    }

    .last-error {
        color: red;
    }

    .bg {
        background-color: #f8f6ff;
    }

    .info-card-color {
        background-color: #fffaeb;
        color: #946c00;
    }

    .info {
        margin-left: 10px;
        margin-right: 10px;
    }

    .table-center {
        text-align: -webkit-center !important;
    }

    .bg-white {
        background-color: white;
    }

    .table-center {
        text-align: -webkit-center !important;
    }

    .color-default {
        color: #6a85a7 !important;
    }

    .bg-default {
        background-color: #f8f6ff !important;
    }

    .search {
        padding: 0;
        margin-bottom: 3em;
    }

    .t-sort {
        border: none;
        background: transparent;
        color: white;
        font-weight: bold;
        font-size: 16px;
        cursor: pointer;
    }

    .sort-icon {
        margin-left: 5px;
        font-size: 18px;
        color: #ffffff69;
    }

    .icon-color-white {
        color: #ffffff;
    }

    .icon-color-default {
        color: #ffffff69;
    }

    .mt-4 {
        margin-top: 1rem;
    }

    .is-justify-content-center {
        justify-content: center;
    }

    .bg-sort-selected {
        background-color: #eae7f3 !important;
    }

    /* RESPONSIVE */

    @media (max-width: 1600px) {
        .cards {
            justify-content: center;
        }
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -400px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

</style>
<script>
    import {mapActions} from "vuex";
    import * as moment from 'moment'
    import Datepicker from 'vuejs-datepicker'
    import PieChart from "../../../components/Chart/PieChart";
    import ArchiveSummaryService from "../../../services/archivesummary.service";

    //import PieChart from "../../../components/Charts/Pie";

    // import PieChart from '../../../components/Charts/Pie';
    /* import BarChart from '../../../components/Charts/BarChart'*/
    // import LineChart from "../../components/Chart/LineChart";
    // import PieChart from "../../components/Chart/PieChart";

    export default {
        name: "ArchiveSummary",
        components: {
            // PieChart
            // PieChart
            /* BarChart,*/
            // LineChart,
            // PieChart
            Datepicker,
            PieChart
        },
        data() {
            return {

                //Sample chart datası
                // SampleDataCollection :{
                //     labels: [
                //         "0",
                //         "1",
                //         "2",
                //         "3",
                //         "4",
                //         "5",
                //         "6",
                //         "7",
                //         "8",
                //     ],
                //     datasets: [
                //         {
                //             label: "DE",
                //             data: [2.7,3.2,0.8,1.2,1.5,1.8,2.5,3.6,3.1,2.4,2.1,2.4,3.1,2.1],
                //             backgroundColor: "transparent",
                //             borderColor: "#2850a7",
                //             pointBackgroundColor: "#2850a7"
                //         },
                //         {
                //             label: "EN",
                //             data: [0,0,1.2,1.3,2.3,2.5,2.6,3.2,3.5,3.2,2.8,2.4,2.1,2.8],
                //             backgroundColor: "transparent",
                //             borderColor: "#da6f00",
                //             pointBackgroundColor: "#da6f00"
                //         },
                //         {
                //             label: "TR",
                //             data: [2,2.3,2.5,2.8,3.5,3.8,3.9,3.2,2.8,3.4,3.6,3.7,3.4,3.3],
                //             backgroundColor: "transparent",
                //             borderColor: "#41454f",
                //             pointBackgroundColor: "#41454f"
                //         }
                //     ]
                // },
                // SampleSampleDataCollection2 :{
                //     hoverBackgroundColor: "red",
                //     hoverBorderWidth: 10,
                //     labels: ["DE", "TR", "EN"],
                //     datasets: [
                //         {
                //             label: "Data One",
                //             backgroundColor: ["#2850a7", "#da6f00", "#41454f"],
                //             data: [1, 10, 5]
                //         }
                //     ]
                // },
                dailyShowModal: false,
                weeklyShowModal: false,
                monthlyShowModal: false,
                lockrendermodal : false,
                daily: [],
                weekly: [],
                monthly: [],

                datepickerDate: new Date(),

                opened: [],
                search: "",
                tempSearch: "",
                archiveConceptList: [],
                analyticsData: [],
                resultCount: 0,
                currentPage: 1,
                pageRange: 3,
                itemsPerPage: 20,
                pageNavigationInfo: {},
                isToggleActived: [],
                iconList: [
                    {
                        type: true,
                        icon: "plus",
                    },
                    {
                        type: false,
                        icon: "minus",
                    },
                    {
                        type: "default",
                        icon: "sort",
                    },
                    {
                        type: "asc",
                        icon: "sort-up",
                    },
                    {
                        type: "desc",
                        icon: "sort-down",
                    }
                ],
                DashboardAnalytics: [
                    {
                        type: "monthly", startDt: "2022-11-06T00:00:00", endDt: "2022-12-06T00:00:00",
                        archivedTotalCount: 36000, archivedErroredCount: 360,
                        archivedTotalSize: 96000, deletedFolderSize: 3600,
                        deletedFolderCount: 3600, deletedErroredCount: 3600
                    },
                    {
                        type: "weekly", startDt: "2022-11-29T00:00:00", endDt: "2022-12-06T00:00:00",
                        archivedTotalCount: 3600, archivedErroredCount: 36,
                        archivedTotalSize: 9600, deletedFolderSize: 360,
                        deletedFolderCount: 360, deletedErroredCount: 360
                    },
                    {
                        type: "daily", startDt: "2022-12-06T00:00:00", endDt: "2022-12-06T00:00:00",
                        archivedTotalCount: 360, archivedErroredCount: 3,
                        archivedTotalSize: 960, deletedFolderSize: 36,
                        deletedFolderCount: 36, deletedErroredCount: 36
                    },
                ],

                sort: 'default',
                sortDir: 'default',

                DashboardAnalytics2: [{
                    "typeAnalytic": "daily",
                    "startDt": "2022-12-06T00:00:00",
                    "endDt": "2022-12-13T14:23:39",
                    "archivedTotalCount": 360,
                    "erroredArchiveCount": 3,
                    "archivedTotalSize": 960,
                    "deletedFolderSize": 36,
                    "deletedFolderCount": 36,
                    "deleteErroredCount": 36
                },
                    {
                        "typeAnalytic": "monthly",
                        "startDt": "2022-06-16T00:00:00",
                        "endDt": "2022-12-13T14:23:39",
                        "archivedTotalCount": 3625,
                        "archivedTotalSize": 130047.60,
                        "erroredArchiveCount": 0,
                        "deletedFolderCount": 3625,
                        "deletedFolderSize": 88358.25,
                        "deleteErroredCount": 0
                    },
                    {
                        "typeAnalytic": "weekly",
                        "startDt": "2022-12-06T00:00:00",
                        "endDt": "2022-12-13T14:23:39",
                        "archivedTotalCount": 2373,
                        "archivedTotalSize": 67451.96,
                        "erroredArchiveCount": 0,
                        "deletedFolderCount": 2373,
                        "deletedFolderSize": 46674.81,
                        "deleteErroredCount": 0
                    }],
            }
        },
        methods: {
            ...mapActions("archivesummary", ["getArchiveConceptListM", "getArchiveTransferAnalytics"]),
            // ...mapActions["getArchiveConceptList"],

            ConvertStringToFloat(value)
            {

                return Number(value.toString().replace(',','.'))//parseFloat(value.toString().replace(',','.'))

            },

            SuccessfullPercentageRateCalculation(SuccessfullVal,ErrorVal)
            {
                if(SuccessfullVal === undefined)
                {
                    SuccessfullVal = 0;
                }
                if(ErrorVal === undefined)
                {
                    ErrorVal = 0;
                }

                SuccessfullVal = this.ConvertStringToFloat(SuccessfullVal)
                ErrorVal = this.ConvertStringToFloat(ErrorVal)

                return   ((SuccessfullVal+ErrorVal)*SuccessfullVal)/100


            },

            async getArchiveStatistics()
            {
                let selectedDate = new Date();
                //this.analyticsData = this.DashboardAnalytics2
                this.analyticsData = await ArchiveSummaryService.getDashboardAnalytics(selectedDate);
                this.daily = await this.analyticsData.find(o => o.typeAnalytic === 'daily')

                this.weekly = await this.analyticsData.find(o => o.typeAnalytic === 'weekly')
                this.monthly = await this.analyticsData.find(o => o.typeAnalytic === 'monthly')

                this.lockrendermodal = true

            },

            async getArchiveConceptList() {
                try {
                    let list = await this.getArchiveConceptListM()
                    //let list = await this.$store.dispatch("archive/getArchiveConceptList")
                    // console.log("List -----------------------------------------")
                    // console.log(list)
                    this.setArchiveConceptList(list);
                } catch (e) {
                    //this.$notify({title: "Error", text: "Error on getArchiveConceptList, " + e.message, type: "error"});
                }
            },
            toggle(id) {
                const index = this.opened.indexOf(id);
                if (index > -1) {
                    this.opened.splice(index, 1)
                    this.isToggleActived[id] = false;
                } else {
                    this.opened.push(id)
                    this.isToggleActived[id] = true;
                }
            },
            icon(opened) {
                if (!opened) {
                    return this.iconList.find(x => x.type === true).icon
                } else {
                    return this.iconList.find(x => x.type === false).icon
                }
            },
            iconToggle(opened) {
                if (!opened) {
                    return this.iconList.find(x => x.type === true).icon
                } else {
                    return this.iconList.find(x => x.type === false).icon
                }
            },
            setResultCount(count) {
                this.resultCount = count;
            },
            setCurrentPage(currentPage) {
                this.currentPage = currentPage;
            },
            setPage(pageNumber) {
                this.currentPage = pageNumber;
                this.buildPageNavigationInfo()
            },
            setArchiveConceptList(list) {
                this.archiveConceptList = list;
            },

            buildPageNavigationInfo() {
                let _total = this.totalPages;
                let _current = this.currentPage;

                let firstPage = Math.max(1, _current - this.pageRange);
                let lastPage = Math.min(_total, _current + this.pageRange);

                this.pageNavigationInfo = {
                    start: firstPage - 1,
                    end: lastPage,
                    hasFirstPageNavigation: firstPage > 1,
                    hasLastPageNavigation: lastPage < _total,
                    pageCount: lastPage - firstPage + 1,
                    total: _total,
                }
            },

            sortBy(sortName) {
                if (sortName === this.sort) {
                    this.sortDir = (this.sortDir === 'asc') ? 'desc' : 'asc';
                } else {
                    this.sortDir = 'asc';
                }
                this.sort = sortName;
            },

            iconSort(sort, name) {
                if (name === this.sort) {
                    return this.iconList.find(x => x.type === sort).icon
                } else {
                    return this.iconList.find(x => x.type === 'default').icon
                }
            },

            async fillsearchField() {
                setTimeout(() => this.tempSearch = this.search, 2000)
            },

            openDateCalendar() {

                var t = Date.now();

                this.highlighted = {dates: [new Date(t)]};
            },

            async TrygetScheduleFlightsfromDatepicker() {
                this.clearScheduleFlights();
                this.searchText = "";
                var t = Date.now();

                this.highlighted = {dates: [new Date(t)]};

                this.SearchDate = moment(this.datepickerDate).format('YYYY-MM-DD');

                this.$router.push({name: 'Schedule', params: {date: this.SearchDate}}).catch(() => {
                });

                this.showLoading();

                try {
                    await this.getScheduleFlights();
                    //this.InitTimeRow();
                } catch (e) {
                    // this.$notify({
                    //     title: "Error",
                    //     text: " Schedule Flights couldn't get. Refresh page. " + e.message,
                    //     type: "error"
                    // });
                } finally {
                    // console.log("TrygetScheduleFlightsfromDatepicker RUN")
                    this.hideLoading();
                }
            },
            customFormatter(date) {
                return moment(date).format('YYYY-MM-DD');
            },
        },
        created() {

            //console.log("analyticsData Geldi")
            //this.analyticsData = this.getArchiveTransferAnalytics(selectedDate);
            this.getArchiveStatistics();

            this.getArchiveConceptList();
            this.currentPage = 1;
            this.buildPageNavigationInfo();


            // console.log(this.daily)
            // console.log(this.weekly)
            // console.log(this.monthly)
            // console.log(analyticsData);
        },
        computed: {
            totalPages() {
                return Math.ceil(this.resultCount / this.itemsPerPage);
            },
            paginate() {
                if (!this.archiveConceptList) {
                    return
                }
                this.setArchiveConceptList(this.archiveConceptList);

                let list = this.archiveConceptList.filter((post) => {
                    return post.id.toString().toLowerCase().match(this.search.toLowerCase())
                        || post.kfz.toString().toLowerCase().match(this.search.toLowerCase())
                        || post.archiveId.toString().toLowerCase().match(this.search.toLowerCase())
                        || post.flightFolderSize.toString().toLowerCase().match(this.search.toLowerCase())
                        || post.stdDay.toString().toLowerCase().match(this.search.toLowerCase())
                        || post.stat.toString().toLowerCase().match(this.search.toLowerCase())
                        || post.lastError.toString().toLowerCase().match(this.search.toLowerCase());
                })
                this.setResultCount(list.length);
                if (this.currentPage === 0) this.setCurrentPage(1)
                if (this.currentPage >= this.totalPages) {
                    this.setCurrentPage(this.totalPages)
                }

                let index = this.currentPage * this.itemsPerPage - this.itemsPerPage
                this.buildPageNavigationInfo()
                return list.slice(index, index + this.itemsPerPage).sort((a, b) => {
                    let dir = (this.sortDir === 'asc') ? 1 : -1;
                    if (a[this.sort] < b[this.sort]) {
                        return -1 * dir;
                    } else if (a[this.sort] > b[this.sort]) {
                        return 1 * dir;
                    } else {
                        return 0;
                    }
                })


            },


        },
        mounted() {
        }
    }
</script>
